import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Autentisering} from "felles/tjenester/Autentisering";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {uriDekodet} from "felles/stoettefunk/uri";
import {Debugger} from "debug";
import {criiptoCallbackParamsFraStateParams} from "felles/komponenter/autentisering/criiptoautentiseringBasis";
import {UIRouterGlobals} from "@uirouter/angularjs";
import {CriiptoBindBrukerFeiletForsøkÅrsak, CriiptoBindFraTokenSesjonstjeneste} from "web/tjenester/CriiptoBindFraTokenSesjonstjeneste";

const debug:Debugger = require('debug')('LoggInnKontroller');
const delt_scss = require('./delt.scss');
const forside_scss = require('./forside.scss');
const logginn_scss = require('./logginn.scss');

/**
 * Håndterer autentisering.
 *
 * Ved criipto-autentisering leser vi criipto-tilstand propagert via url queryparametere og eksponerer denne via
 * {@link #criiptoCallbackparams} som så sendes til {@link CriiptoAutentiseringBasis}.
 */
export class LoggInnKontroller {

    static regNavn = "web.LoggInnKontroller";

    static forInjisering() {
        return [
            regNavn.ng.ui.$uiRouterGlobals,
            Autentisering.regNavn,
            WebNavigasjon.regNavn,
            CriiptoBindFraTokenSesjonstjeneste.regNavn,
            LoggInnKontroller
        ]
    }

    constructor(private $uiRouterGlobals: UIRouterGlobals,
                private autentisering: Autentisering,
                private navigasjon: WebNavigasjon,
                private criiptoBindFraTokenSesjonstjeneste: CriiptoBindFraTokenSesjonstjeneste) {
        this.criiptoCallbackparams = criiptoCallbackParamsFraStateParams(this.$uiRouterGlobals.params);
        if (autentisering.erAutentisert()) navigasjon.gåTilStartsiden();
    }

    criiptoCallbackparams:l.CriiptoCallbackParams;

    autentisert(autentisert:l.AutentisertOkModell){
        // Bruker kommer fra nytt passord-prosess og er nå autentisert mot sp3

        //dersom vi kommer hit som følge av at bruker har klikket på en passord-reset-lenke og i den flyten valgt bankid
        //vil epostOgTokenErSatt() returnerer sann
        if(this.criiptoBindFraTokenSesjonstjeneste.epostOgTokenErSatt() &&
          !this.håndterEidBundetViaResettoken(autentisert)) return;

        const forespurtSide = uriDekodet(sessionStorage.getItem("forespurtSide"));
        sessionStorage.removeItem("forespurtSide");
        this.navigasjon.gåTilSti(forespurtSide);
    }

    //hjelpemetoder

    /** håndter situasjon der bruker har autentisert med bankid som allerede er bundet til annen bruker.
     * Returnerer true dersom alt ok, false dersom prosessen må avbrytes */
    private håndterEidBundetViaResettoken(autentisert: l.AutentisertOkModell) {
        if (autentisert.bruker.epost == this.criiptoBindFraTokenSesjonstjeneste.epost()) return true;

        debug('Bind eid via resettoken - bruker autentiserte med eid som er knyttet til annen bruker')
        this.criiptoBindFraTokenSesjonstjeneste.angiFeiletForsøkInformasjon(
          CriiptoBindBrukerFeiletForsøkÅrsak.annenBrukerKnyttetTilAngittEid,
          this.criiptoBindFraTokenSesjonstjeneste.epost(),
          autentisert.bruker.epost
        );
        // nullstiller for å sikre at et nytt innloggingsforsøk bruker ren tilstand
        // alternativt kunne vi stolt på at gåTilBindBrukerOpenIdEpostMismatch gjør alt riktig
        this.criiptoBindFraTokenSesjonstjeneste.nullstill();
        // logg ut brukeren igjen, og send videre til feiltilstand-siden
        this.autentisering.loggUt()
          .then(() => {
              this.navigasjon.gåTilBindBrukerOpenIdFeilet()
          });
        return false;
    }

}
